import EditLocation from './edit-location.connect'

export default EditLocation
